import React, { ReactElement } from "react";
import { getAuthorizedNavItems } from "./navItems";
import TopMenuLink from "./topMenuLink";

export default function TopMenu(): ReactElement {
  return (
    <React.Fragment>
      {getAuthorizedNavItems().map((navItem) => (
        <TopMenuLink key={navItem.title} {...navItem} />
      ))}
    </React.Fragment>
  );
}
